import { Button, Form, Input, message } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { AuthService } from "@services/auth.service";
import { useEffect, useState } from "react";
// import { AndroidDataEventMap } from "@declarations/event"; // biometric belum terpakai
// import { androidLoginBiometric } from "@utils/android"; // biometric belum terpakai
import { NoticeType } from "antd/es/message/interface";

export const LoginPage = () => {
  const navigate = useNavigate();
  // const [form] = Form.useForm<{ username: string; password: string }>(); // hanya dipakai untuk auto-fill biometric, belum terpakai
  const [messageApi, contextHolder] = message.useMessage();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  const [messageType, setMessageType] = useState<string>("");

  // Biometric login — belum terpakai, dinonaktifkan sementara
  // const listener = useCallback(
  //   (ev: MessageEvent<AndroidDataEventMap["on-login-biometric"]>) => {
  //     form.setFieldsValue(ev.data);
  //     form.submit();
  //   },
  //   [form],
  // );
  //
  // useEffect(() => {
  //   const requestBiometric = setTimeout(() => {
  //     androidLoginBiometric();
  //   }, 500);
  //   window.addEventListener("on-login-biometric", listener);
  //
  //   return () => {
  //     clearTimeout(requestBiometric);
  //     window.removeEventListener("on-login-biometric", listener);
  //   };
  // }, [listener]);
  // const {
  //   register,
  //   handleSubmit,
  //   formState: { errors },
  // } = useForm<AuthLogin>({
  //   resolver: yupResolver<AuthLogin>(authLoginSchema),
  // });

  const { mutate, isPending } = useMutation({
    mutationFn: AuthService.login,
    onSuccess: (response) => {
      if (response.success) {
        navigate(response.data!.redirect);
      } else {
        setShowMessage(true);
        setMessageType("error");
        setShowMessageText(response.message);
      }
    },
  });

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: messageType as NoticeType,
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText, messageType, messageApi]);

  return (
    <>
      {contextHolder}
      <div
        className="tw-px-5 tw-relative tw-z-10"
        style={{ marginTop: "-56px" }}
      >
        <div className="card-body tw-rounded-3xl tw-px-6 tw-py-7">
          <div className="tw-mb-1 tw-text-xl tw-font-bold tw-text-text-primary tw-text-center">
            Masuk ke Akun
          </div>
          <div className="tw-text-xs tw-text-text-secondary tw-text-center tw-mb-7">
            Silakan masukkan data Anda untuk melanjutkan
          </div>
          <Form name="basis" layout="vertical" onFinish={(data) => mutate(data)}>
            <Form.Item
              name="username"
              rules={[{ required: true, message: "NIS tidak boleh kosong!" }]}
            >
              <Input
                prefix={<UserOutlined style={{ color: "#56b6fd" }} />}
                className="tw-shadow-none tw-text-base tw-rounded-xl tw-border tw-border-background-300"
                placeholder="NIS/Nomor Induk Siswa"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Password tidak boleh kosong!" },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: "#56b6fd" }} />}
                className="tw-shadow-none tw-text-base tw-rounded-xl tw-border tw-border-background-300"
                placeholder="Password"
              />
            </Form.Item>

            <Form.Item className="tw-w-full tw-mb-0 tw-mt-8">
              <Button
                className="tw-h-11 tw-w-full tw-block tw-mx-auto tw-text-base tw-font-semibold tw-text-white tw-rounded-xl tw-border-0 focus:tw-shadow-none bg-gradient"
                htmlType="submit"
                loading={isPending}
              >
                Masuk
              </Button>
            </Form.Item>
          </Form>
        </div>

        <div className="tw-text-xs tw-text-text-secondary tw-text-center tw-mt-6 tw-pb-8">
          Silahkan hubungi{" "}
          <span className="tw-text-primary tw-font-bold">Admin</span> jika
          terjadi masalah terhadap aplikasi
        </div>
      </div>
    </>
  );
};
